import { useCallback, useState, useEffect } from 'react'
import { withStyles } from '@aura/components/styles'
import Box from '@aura/components/box'
import IconButton from '@aura/components/icon-button'
import Menu from '@aura/components/menu'
import MenuItem from '@aura/components/menu-item'
import Typography from '@aura/components/typography'
import clsx from 'clsx'
import DoneIcon from '@mui/icons-material/Done'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import LanguageIcon from '@mui/icons-material/Language'
import { isEnglish, isFrench } from '../../constants/app'
import constants from '../../constants/languages'
import { REGISTRATION_ROUTE, FORGOTPWD_ROUTE, SESSION_TIMEOUT, ANALYTICS_REGISTER, LOGIN_ROUTE, MAGIC_LINK, DEFAULT_REGISTER, PASSWORD_CHANGED } from '../../constants/routes'
import styles from './styles'


const Component = ({
    classes,
    clsName,
    component,
    loginTitle,
    validateForm,
    variant
}) => {

    const { t: translate, i18n } = useTranslation()
    const history = useHistory()
    const [ selectedLang, setSelectedLang ] = useState(i18n.language)
    const [ anchorEl, setAnchorEl ] = useState(null)

    const isOpen = Boolean(anchorEl)
    const handleClose = () => {
        setAnchorEl(null)
    }

    useEffect(() => {
        setSelectedLang(i18n.language)
    }, [ i18n.language ])

    const toggleLanguage = useCallback(async event => {
        let newlang = ''
        let newPath = ''
        if (isEnglish(i18n.language)) {
            newlang = constants.FRENCH
        } else if (isFrench(i18n.language)) {
            newlang = constants.ENGLISH
        }
        if (window.location.pathname.endsWith(`/${constants.ENGLISH}`) || window.location.pathname.endsWith(`/${constants.FRENCH}`)) {
            newPath = window.location.pathname.slice(0, -2) + newlang
        } else {
            if (window.location.pathname.endsWith('/')) {
                newPath = window.location.pathname + newlang
            } else {
                newPath = window.location.pathname + '/' + newlang
            }
        }
        i18n.changeLanguage(newlang)
        document.title = translate(loginTitle)
        if (component !== LOGIN_ROUTE) {
            if (!newPath.startsWith(FORGOTPWD_ROUTE) && !newPath.startsWith(REGISTRATION_ROUTE) && !newPath.startsWith(MAGIC_LINK)) {
                if (newPath.startsWith(PASSWORD_CHANGED)) {
                    return
                } else if (newPath.startsWith(SESSION_TIMEOUT) || newPath.startsWith('/message') || newPath.startsWith('/error')) {
                    history.goForward()
                } else {
                    history.push(newPath)
                }
            } else if (newPath.startsWith(FORGOTPWD_ROUTE) || newPath.startsWith(REGISTRATION_ROUTE) || newPath.startsWith(ANALYTICS_REGISTER) || newPath.startsWith(MAGIC_LINK)) {
                const params = new URLSearchParams(window.location.search)
                params.set('language', newlang)
                const newSearch = params.toString()
                history.replace(`${window.location.pathname}?${newSearch}`)
            }
        } else {
            if (newPath.startsWith(PASSWORD_CHANGED)) {
                return
            }
            validateForm?.()
            history.push(newPath)
        }
    }, [ i18n.language, component, loginTitle, translate, history, validateForm ])

    const toggleFrench = useCallback(() => {
        /^en\b/.test(i18n.language) && toggleLanguage()
        handleClose()
    }, [ i18n.language, toggleLanguage ])

    const toggleEnglish = useCallback(() => {
        /^fr\b/.test(i18n.language) && toggleLanguage()
        handleClose()
    }, [ i18n.language, toggleLanguage ])

    const handleLanguageMenuClick = useCallback(event => {
        setAnchorEl(event.currentTarget)
    }, [ ])

    return (
        <Box className={classes.languageMenuItem}>
            <IconButton color='inherit' onClick={handleLanguageMenuClick}>
                <LanguageIcon className={clsx(classes.languageMenuIcon, { [classes.menuIconActive]: isOpen })} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                disableScrollLock
                classes={{ paper: clsx(classes.languageMenu, component === DEFAULT_REGISTER && classes.languageMenuDefaultRegister) }}
            >
                <Box className={classes.languageMenuBox}>
                    <MenuItem onClick={toggleFrench} className={clsx(classes.languageMenuItems, { [classes.languageMenuItemsActive]: selectedLang === constants.FRENCH })}>
                        <LanguageIcon className={clsx(classes.languageMenuIconSub)} />
                        <Typography className={classes.languageMenuText}>{ isFrench(i18n.language) ? 'Francais' : 'French' }</Typography>
                        {selectedLang === constants.FRENCH && <DoneIcon className={clsx(classes.doneMenuIcon)} />}
                    </MenuItem>
                    <MenuItem onClick={toggleEnglish} className={clsx(classes.languageMenuItems, { [classes.languageMenuItemsActive]: selectedLang === constants.ENGLISH })}>
                        <LanguageIcon className={clsx(classes.languageMenuIconSub)} />
                        <Typography className={classes.languageMenuText}>{ 'English' }</Typography>
                        {selectedLang === constants.ENGLISH && <DoneIcon className={clsx(classes.doneMenuIcon)} />}
                    </MenuItem>
                </Box>
            </Menu>
        </Box>
    )
}
Component.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(Component, styles)


